// CREATE TABLE [dbo].[tStyle] (
//     [fTemplatename]                            TEXT           NULL,
//     [fFrameSplit]                              INT            NULL,
//     [fFPS]                                INT            NULL,
//     [fClientId]                                INT            NULL,
//     [fLanguages]                               NVARCHAR (250) NULL,
//     [fIsUseResolutionXY]                                INT            NULL,
//     [fResolutionX]                                INT            NULL,
//     [fResolutionY]                                INT            NULL,
//     [fCharacterByteType]                                INT            DEFAULT 0 NOT NULL,
//     [fMinLengthPerLine]                        INT            NULL,
//     [fMaxLengthPerLine]                        INT            NULL,
//     [fIsCharacterPerSecondType]                                INT            DEFAULT 0 NOT NULL,
//     [fMinLengthPerSecond]                      INT            NULL,
//     [fMaxLengthPerSecond]                      INT            NULL,
//     [fIsExcludeSpaces]                                INT            DEFAULT 1 NOT NULL,
//     [fIsExcludePunctuations]                                INT            DEFAULT 1 NOT NULL,
//     [fMaxDurationSecond]                       INT            NULL,
//     [fMaxDurationFram]                         INT            NULL,
//     [fMinDurationSecond]                       INT            NULL,
//     [fMinDurationFram]                         INT            NULL,
//     [fMaxCountOfLines]                         INT            NULL,
//     [fSaveAreaXLeft]                           INT            DEFAULT 75 NOT NULL,
//     [fSaveAreaXRight]                          INT          DEFAULT 75 NOT NULL,
//     [fSaveAreaYTop]                            INT            DEFAULT 90 NOT NULL,
//     [fSaveAreaYBottom]                         INT            DEFAULT 90 NOT NULL,
//     [fFontId]                                  INT            DEFAULT 0 NOT NULL,
//     [fFontSize]                                INT           DEFAULT 12 NOT NULL,
//     [fLineSpacing]                             INT            NULL,
//     [fCharaterSpacing]                         INT            NULL,
//     [fIsAllowPositioning]                         INT            NULL,
//     [fAllowPositioningType]                    INT            NULL,
//     [fCenterJustificationType]                 INT            NULL,
//     [fIsRemoveContinuousWhitespace]            INT            DEFAULT 1 NOT NULL,
//     [fQC_MissingTimecodeError]                 INT            DEFAULT 1 NOT NULL,
//     [fQC_TimecodeOverlapError]                 INT            DEFAULT 1 NOT NULL,
//     [fQC_DurationError_min]                    INT            DEFAULT 1 NOT NULL,
//     [fQC_DurationError_max]                    INT            DEFAULT 1 NOT NULL,
//     [fQC_EmptySubError]                        INT            DEFAULT 1 NOT NULL,
//     [fQC_ChartacterLimtError]                  INT            DEFAULT 1 NOT NULL,
//     [fQC_ReadSpeedError]                       INT            DEFAULT 1 NOT NULL,
//     [fQC_MaxLineError]                         INT            DEFAULT 1 NOT NULL,
//     [fQC_PositionCheckError]                   INT            DEFAULT 1 NOT NULL,
//     [fQC_NetflixWhitelistCharactersCheckError] INT            DEFAULT 1 NOT NULL,
//     [fQC_Half_white_ChartaterError]            INT            DEFAULT 1 NOT NULL,
//     [fQC_SimplifiedError]                      INT            DEFAULT 1 NOT NULL,
//     PRIMARY KEY CLUSTERED ([fStyleId] ASC)
// );
//



import React, {useEffect, useState} from 'react';
import { useHistory ,useLocation} from 'react-router-dom';
import {Form, Input,Divider} from 'semantic-ui-react';
import { Grid, Segment,Select,Button,Checkbox} from 'semantic-ui-react';
import Spinner from "../common/Spinner";
import styled from "styled-components";
import Slider, { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';
import ApiUtils from "../../helper/ApiUtils";

const CaptionContainer= styled.div`  
  text-align: ${props => props.textAlign};
  position: absolute;
  bottom: ${props => props.bottom};
  left: 0;
  right: 0;
  top: ${props => props.top};
  color: white;
  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000,  1px 1px 0 #000;
  lineHeight:130%;
  letter-spacing: 1px;
  font-size:${props => props.fontSize}pt;
  `;


const StylePage_Add = ({type,editData,finishUpdate}) => {
    this.captionTextRef = React.createRef();

    const history = useHistory();
    const location = useLocation();
 
   
    //網址判斷
    useEffect(() => {

        // post_Style_GetClientList
         getClient();

    }, [location]);



    const getClient = async ()=>{

        /**
         * 廠商
         * */
        const getClient_jsonData = await ApiUtils.post_sql(`${ApiUtils.post_Style_GetClientList}`);
        // [{"fId":1,"fName":"Medialink Group Ltd.","fEmail":null,"fPhone":null,"fSerialNumber":null,"fLevel":1},{"fId":2,"fName":"酷遊天國際旅行社股份有限公司","fEmail":null,"fPhone":null,"fSerialNumber":null,"fLevel":1}]

        //第一個為預設
        const firstobj = getClient_jsonData[0];
        setfClientId(firstobj.fId);
        setClientTitle(firstobj.fName);
　
        //客戶列表
        let clients = [];
        getClient_jsonData.map((data)=>{
            const {fId,fName} = data;
            clients.push({ key: fId, value: fId, text: fName })
        });
        setclientList(clients);

        /**
         * 語系
         * */
        const　LanguageList_jsonData = await ApiUtils.post_sql(`${ApiUtils.post_Style_GetLanguageList}`);
        //語系列表
        setLanguageList(LanguageList_jsonData);
        // {
        //     "fId": 1,
        //     "fName": "繁體中文",
        //     "fCode": "zhtw",
        //     "fCountry": null
        // },

        /**
         * 基本資料拿完後，開始設定編輯內容
         * */　
        if(type === 'edit'){
            //分配數值
            setfStyleId(editData.fStyleId);
            setfTemplatename(editData.fTemplatename);
            setfFrameSplit(editData.fFrameSplit);
            setfFPS(editData.fFPS);

            //客戶
            const clientArray = getClient_jsonData.filter(data=> parseFloat(data['fId']) === parseFloat(editData.fClientId));　
            setfClientId(editData.fClientId);
            if(clientArray.length > 0){
                setClientTitle(clientArray[0].fName);
            }else{  
                setClientTitle("");
            }

            if(editData.fLanguages !== null){
                const uWant  = `${editData.fLanguages}`.split(",");
                // console.log(uWant);
                setUserWantLanguageList(uWant);
            }

            setfIsUseResolutionXY(editData.fIsUseResolutionXY===1?true:false);
            setfResolutionX(editData.fResolutionX);
            setfResolutionY(editData.fResolutionY);

            setfCharacterByteType(editData.fCharacterByteType===1?true:false);
            setfMinLengthPerLine(editData.fMinLengthPerLine);
            setfMaxLengthPerLine(editData.fMaxLengthPerLine);

            setfIsCharacterPerSecondType(editData.fIsCharacterPerSecondType===1?true:false);
            setfMinLengthPerSecond(editData.fMinLengthPerSecond);
            setfMaxLengthPerSecond(editData.fMaxLengthPerSecond);

            setfIsExcludeSpaces(editData.fIsExcludeSpaces===1?true:false);
            setfIsExcludePunctuations(editData.fIsExcludePunctuations===1?true:false);

            setfMaxDurationSecond(editData.fMaxDurationSecond.toString().padStart(2, '0'));
            setfMaxDurationFram(editData.fMaxDurationFram.toString().padStart(2, '0'));

            setfMinDurationSecond(editData.fMinDurationSecond.toString().padStart(2, '0'));
            setfMinDurationFram(editData.fMinDurationFram.toString().padStart(2, '0'));

            setfMaxCountOfLines(editData.fMaxCountOfLines);

            setfSaveAreaXLeft(editData.fSaveAreaXLeft);
            setfSaveAreaXRight(editData.fSaveAreaXRight);

            setfSaveAreaYTop(editData.fSaveAreaYTop);
            setfSaveAreaYBottom(editData.fSaveAreaYBottom);

            setfFontId(editData.fFontId);
            setfFontSize(editData.fFontSize);

            setfLineSpacing(editData.fLineSpacing);
            setfCharaterSpacing(editData.fCharaterSpacing);

            setfIsAllowPositioning(editData.fIsAllowPositioning);
            setfAllowPositioningType(editData.fAllowPositioningType===1?true:false);
            setfCenterJustificationType(editData.fCenterJustificationType);

            setfIsRemoveContinuousWhitespace(editData.fIsRemoveContinuousWhitespace===1?true:false);

            //QC
            setfQC_MissingTimecodeError(editData.fQC_MissingTimecodeError===1?true:false);
            setfQC_TimecodeOverlapError(editData.fQC_TimecodeOverlapError===1?true:false);
            setfQC_DurationError_min(editData.fQC_DurationError_min===1?true:false);
            setfQC_DurationError_max(editData.fQC_DurationError_max===1?true:false);
            setfQC_EmptySubError(editData.fQC_EmptySubError===1?true:false);
            setfQC_ChartacterLimtError(editData.fQC_ChartacterLimtError===1?true:false);
            setfQC_ReadSpeedError(editData.fQC_ReadSpeedError===1?true:false);
            setfQC_MaxLineError(editData.fQC_MaxLineError===1?true:false);
            setfQC_PositionCheckError(editData.fQC_PositionCheckError===1?true:false);
            setfQC_NetflixWhitelistCharactersCheckError(editData.fQC_NetflixWhitelistCharactersCheckError===1?true:false);
            setfQC_Half_white_ChartaterError(editData.fQC_Half_white_ChartaterError===1?true:false);
            setfQC_SimplifiedError(editData.fQC_SimplifiedError===1?true:false);
        }

    }


    const [fStyleId,setfStyleId] = useState(0);
    const [loading,setloading] = useState(false);
    const [fTemplatename,setfTemplatename] = useState('');
    const [fFrameSplit,setfFrameSplit] = useState(2);
    const [fFPS,setfFPS] = useState(25);
    const [fClientId,setfClientId] = useState(1);
    const [ClientTitle,setClientTitle] = useState('');
    const [UserWantLanguageList,setUserWantLanguageList] = useState([]);//用戶想要的語系
    const [LanguageList,setLanguageList] = useState([]); //語系選項

    //CaptionContainer 相關參數
    const [CaptionContainer_txt,setCaptionContainer_txt] = useState('');
    const [textAlign,settextAlign] = useState('center');
    const [top,settop] = useState('');
    const [bottom,setbottom] = useState('20px');
    const [fFontSize,setfFontSize] = useState(12);
    const [fLineSpacing,setfLineSpacing] = useState(16);
    const [fCharaterSpacing,setfCharaterSpacing] = useState(2);
    const [fIsAllowPositioning,setfIsAllowPositioning] = useState(0);
    const [fFontId,setfFontId] = useState(0);
    const [fFontFamily,setfFontFamily] = useState(0);

    //比例
    const [fResolutionX,setfResolutionX] = useState(16);
    const [fResolutionY,setfResolutionY] = useState(9);
    const [fIsUseResolutionXY,setfIsUseResolutionXY] = useState(true);

    //字數計算
    const [fCharacterByteType,setfCharacterByteType] = useState(true);
    const [fMinLengthPerLine,setfMinLengthPerLine] = useState(0);
    const [fMaxLengthPerLine,setfMaxLengthPerLine] = useState(13);

    //每秒或是 每分鐘幾個字
    const [fIsCharacterPerSecondType,setfIsCharacterPerSecondType] = useState(true);
    const [fMinLengthPerSecond,setfMinLengthPerSecond] = useState(0);
    const [fMaxLengthPerSecond,setfMaxLengthPerSecond] = useState(99);

    const [fIsExcludeSpaces,setfIsExcludeSpaces] = useState(true);
    const [fIsExcludePunctuations,setfIsExcludePunctuations] = useState(true);

    //顯示長度
    const [fMaxDurationSecond,setfMaxDurationSecond] = useState('08');
    const [fMaxDurationFram,setfMaxDurationFram] = useState('00');
    const [fMinDurationSecond,setfMinDurationSecond] = useState('00');
    const [fMinDurationFram,setfMinDurationFram] = useState('20');

    //安全區域
    const [fSaveAreaXLeft,setfSaveAreaXLeft] = useState(77);
    const [fSaveAreaXRight,setfSaveAreaXRight] = useState(77);
    const [fSaveAreaYTop,setfSaveAreaYTop] = useState(82);
    const [fSaveAreaYBottom,setfSaveAreaYBottom] = useState(82);


    //最多的行數限制
    const [fMaxCountOfLines,setfMaxCountOfLines] = useState(2);

    //字幕位置
    const [fAllowPositioningType,setfAllowPositioningType] = useState(true);
    const [fCenterJustificationType,setfCenterJustificationType] = useState(1);
    const [fIsRemoveContinuousWhitespace,setfIsRemoveContinuousWhitespace] = useState(true);

    //QC
    const [fQC_MissingTimecodeError,setfQC_MissingTimecodeError] = useState(true);
    const [fQC_TimecodeOverlapError,setfQC_TimecodeOverlapError] = useState(true);
    const [fQC_DurationError_min,setfQC_DurationError_min] = useState(true);
    const [fQC_DurationError_max,setfQC_DurationError_max] = useState(true);
    const [fQC_EmptySubError,setfQC_EmptySubError] = useState(true);
    const [fQC_ChartacterLimtError,setfQC_ChartacterLimtError] = useState(true);
    const [fQC_ReadSpeedError,setfQC_ReadSpeedError] = useState(true);
    const [fQC_MaxLineError,setfQC_MaxLineError] = useState(true);
    const [fQC_PositionCheckError,setfQC_PositionCheckError] = useState(true);
    const [fQC_NetflixWhitelistCharactersCheckError,setfQC_NetflixWhitelistCharactersCheckError] = useState(true);
    const [fQC_Half_white_ChartaterError,setfQC_Half_white_ChartaterError] = useState(true);
    const [fQC_SimplifiedError,setfQC_SimplifiedError] = useState(true);

    //廠商
    const [clientList,setclientList] = useState([
        { key: '', value: '', text: '' }
    ]);

    const [fontList,setfontList] = useState([
        { key: '0', value: '0', text: 'Arial' },
        { key: '0', value: '1', text: 'Courier New' },
        { key: '0', value: '2', text: 'Georgia' },
        { key: '0', value: '3', text: 'SimSun' },
        { key: '0', value: '4', text: 'Tahoma' },
        { key: '0', value: '5', text: 'Time New Roman' },
        { key: '0', value: '6', text: 'Trebuchet MS' },
        { key: '0', value: '7', text: 'Verdana' }
    ]);

    //儲存
    const SaveAddStyle = async ()=>{

        let sqlData = {
            fTemplatename:fTemplatename,
            fFrameSplit:parseFloat(fFrameSplit),
            fFPS:parseFloat(fFPS),
            fClientId:parseFloat(fClientId),
            fLanguages:UserWantLanguageList.toString(),
            fIsUseResolutionXY:fIsUseResolutionXY===true?1:0,
            fResolutionX:parseFloat(fResolutionX),
            fResolutionY:parseFloat(fResolutionY),
            fCharacterByteType:fCharacterByteType===true?1:0,
            fMinLengthPerLine:parseFloat(fMinLengthPerLine),
            fMaxLengthPerLine:parseFloat(fMaxLengthPerLine),
            fIsCharacterPerSecondType:fIsCharacterPerSecondType===true?1:0,
            fMinLengthPerSecond:parseFloat(fMinLengthPerSecond),
            fMaxLengthPerSecond:parseFloat(fMaxLengthPerSecond),
            fIsExcludeSpaces:fIsExcludeSpaces===true?1:0,
            fIsExcludePunctuations:fIsExcludePunctuations===true?1:0,
            fMaxDurationSecond:parseFloat(fMaxDurationSecond),
            fMaxDurationFram:parseFloat(fMaxDurationFram),
            fMinDurationSecond:parseFloat(fMinDurationSecond),
            fMinDurationFram:parseFloat(fMinDurationFram),
            fMaxCountOfLines:parseFloat(fMaxCountOfLines),
            fSaveAreaXLeft:parseFloat(fSaveAreaXLeft),
            fSaveAreaXRight:parseFloat(fSaveAreaXRight),
            fSaveAreaYTop:parseFloat(fSaveAreaYTop),
            fSaveAreaYBottom:parseFloat(fSaveAreaYBottom),
            fFontId:parseFloat(fFontId),
            fFontSize:parseFloat(fFontSize),
            fLineSpacing:parseFloat(fLineSpacing),
            fCharaterSpacing:parseFloat(fCharaterSpacing),
            fIsAllowPositioning:0,
            fAllowPositioningType:fAllowPositioningType===true?1:0,
            fCenterJustificationType:parseFloat(fCenterJustificationType),
            fIsRemoveContinuousWhitespace:fIsRemoveContinuousWhitespace===true?1:0,
            fQC_MissingTimecodeError:fQC_MissingTimecodeError===true?1:0,
            fQC_TimecodeOverlapError:fQC_TimecodeOverlapError===true?1:0,
            fQC_DurationError_min:fQC_DurationError_min===true?1:0,
            fQC_DurationError_max:fQC_DurationError_max===true?1:0,
            fQC_EmptySubError:fQC_EmptySubError===true?1:0,
            fQC_ChartacterLimtError:fQC_ChartacterLimtError===true?1:0,
            fQC_ReadSpeedError:fQC_ReadSpeedError===true?1:0,
            fQC_MaxLineError:fQC_MaxLineError===true?1:0,
            fQC_PositionCheckError:fQC_PositionCheckError===true?1:0,
            fQC_NetflixWhitelistCharactersCheckError:fQC_NetflixWhitelistCharactersCheckError===true?1:0,
            fQC_Half_white_ChartaterError:fQC_Half_white_ChartaterError===true?1:0,
            fQC_SimplifiedError:fQC_SimplifiedError===true?1:0,
        };

        if(type !== 'Add'){
            //編輯 要加上ID
        }

        await ApiUtils.post_sql(`${ApiUtils.post_AddNewStyle_p}`,{
            postStyle:sqlData,
            fStyleId:fStyleId
        });

        finishUpdate();

        window.location.reload();
    }



    //語系按鈕
    const getLanguageView = ()=>{
       //UserWantLanguageList

        let buttons = [];
        LanguageList.map((data,index)=>{

            const {fName,fId} = data;

            let selected = false;
            UserWantLanguageList.map(data=>{
                if(selected === false && parseFloat(data) === parseFloat(fId) ){
                    selected = true;
                }
            })


            buttons.push(<Button
                className="mb-2"
                key={index}
                size='mini'
                color={selected===true?'blue':'grey'}
            onClick={()=>{
                //點下去新增或是刪除

                if(selected===false){
                    let newlist = UserWantLanguageList;
                    newlist.push(fId);

                    var result = [...(new Set(newlist))];
　
                    setUserWantLanguageList(result);
                }else{
                    const filteredItems = UserWantLanguageList.filter(item => item !== fId);
                    setUserWantLanguageList(filteredItems);
                }

            }}
            >{fName} </Button>);
        })

        return buttons;
    }



    const videoWidth = 458;
    const videoheight = videoWidth*fResolutionY/fResolutionX;
    const saveRight = (100-fSaveAreaXRight);
    const saveLeft = (100-fSaveAreaXLeft);
    const saveTop = (100-fSaveAreaYTop);
    const saveBottom = (100-fSaveAreaYBottom);

    /** 最後處理的按鈕*/
    const actionbutton = ()=>{

        if(type === 'add'){
            return <div>
                <Button color='teal' onClick={()=>{
                    SaveAddStyle();
                }}>
                    Save
                </Button>
            </div>
        }else{
            return <div>
                <Button color='teal' onClick={()=>{
                    SaveAddStyle();
                }}>
                    Save Edit
                </Button>
            </div>
        } 
    }
    const styleFbg = {
        backgroundColor: '#fef8e4',
    };
    return <div className=' pb-2 position-relative' >

        {(loading===true)?<Spinner/>:<div className='p-5'>

            <Grid divided='vertically'>

                <Grid.Row columns={3}>
                    <Grid.Column className='p-0' style={{width:`${videoWidth}px`}}>
                        <div className=" position-relative " style={{
                            width:`${videoWidth}px`,
                            height: 'fit-content'}}  id={" "} >

                            <div
                                style={{width:`${videoWidth}px`,height:`${videoheight}px`,backgroundColor:'#426cff'}}
                            />
                            <div id="safearea"
                                 style={{left:`${saveLeft}px`, right:`${saveRight}px`, top: `${saveTop}px`, bottom:`${saveBottom}px`}}/>
                            <CaptionContainer
                                id="CaptionContainer"
                                textAlign={textAlign}
                                top={top}
                                bottom={`${saveBottom }px`}
                                fontSize={fFontSize}  >
                                <div
                                    ref={ref=>this.captionTextRef = ref}
                                    className="font-1 nowrap  " id="caption-text"
                                    style={{
                                        fontFamily:`${fFontFamily}`,
                                        fontSize: `${fFontSize}px`,
                                        display: 'inline-block',
                                        paddingLeft: '30px',
                                        paddingRight: '30px',
                                        letterSpacing: `${fCharaterSpacing}px`,
                                        lineHeight: `${fLineSpacing}px`
                                    }} >Test
                                </div>
                            </CaptionContainer>
                        </div>

                        <Form.Field className=' ' style={{width:'458px'}} control='textarea' rows='3' value={CaptionContainer_txt}
                                    onChange={(event)=> {
                                        setCaptionContainer_txt(event.target.value);

                                        let SubtitleCaption = event.target.value;
                                        if (SubtitleCaption !== '') {
                                            let newTextArray = SubtitleCaption.split('\n');

                                            if (newTextArray.length > 1) {
                                                //多行
                                                let newTextArrayToString = newTextArray.join("<br/>");
                                                this.captionTextRef.innerHTML = newTextArrayToString;

                                                // displayString = newTextArrayToString;

                                            } else {
                                                //單行
                                                this.captionTextRef.innerHTML = SubtitleCaption;

                                                // displayString = SubtitleCaption;
                                            }

                                        }else{
                                            this.captionTextRef.innerHTML = '';
                                        }
                                    }} />


                        <Form className='   mt-2'>
                            <Segment className='stylefBG' style={styleFbg}>
                                <Form.Group widths='equal' className='stylefBG' >
                                    <Form.Field className='stylefBG'>
                                        <label>Template Name</label>
                                        <Input
                                            placeholder='Template Name'
                                            autoFocus
                                            type="text"
                                            value={fTemplatename}
                                            onChange={(e) => {
                                                setfTemplatename(e.target.value)
                                            }} />
                                    </Form.Field >
                                    <Form.Field className='stylefBG'>
                                        <label>Frame Split</label>
                                        <Input
                                            style={{width:'80px'}}
                                            type="text"
                                            value={fFrameSplit}
                                            onChange={(e) => {
                                                setfFrameSplit(e.target.value)
                                            }} />
                                    </Form.Field>
                                    <Form.Field>
                                        <label>FPS</label>
                                        <Input
                                            style={{width:'80px'}}
                                            type="text"
                                            value={fFPS}
                                            onChange={(e) => {
                                                setfFPS(e.target.value)
                                            }} />
                                    </Form.Field>
                                </Form.Group>

                                <Form.Group widths='equal'>
                                    <Form.Field >
                                        <label>Client</label>
                                        {/* <Select placeholder={ClientTitle}  options={clientList}  onChange={(event, result) => {

console.log(event)
console.log(result)

                                            const { value } = result || event.target;

                                            const obj = fontList[parseInt(value)];
                                            const {text} = obj;
                                            setfClientId(value);
                                            setClientTitle(text);
                                        }} /> */}

                                <select  placeholder={ClientTitle}  onChange={(event, result) => {
 
                                            var index = event.nativeEvent.target.selectedIndex;
                                            var titleText = event.nativeEvent.target[index].text; 
 
                                            setfClientId( event.target.value);
                                            setClientTitle(titleText);
                                        }}>

                                            
                                        {clientList.map((opt, i) => {  
                                            const {key,value,text} =    opt;             
                                                return (<option selected={ClientTitle===text} key={i} value={value}>{text}</option>) 
                                                })}  

                                </select>

                                    </Form.Field>
                                </Form.Group>

                                <Form.Group widths='equal'>
                                    <Form.Field >
                                        <label>Language</label>
                                        {getLanguageView()} 
                                    </Form.Field>
                                </Form.Group>

                            </Segment>

                            <Segment style={styleFbg}>
                                <Form.Group widths='equal' >
                                    <Form.Field>
                                        <Checkbox style={{width:'220px',    border: 'none'}} label='Resolution'
                                                  checked={fIsUseResolutionXY}
                                                  onChange={(e) => {
                                                      setfIsUseResolutionXY(!fIsUseResolutionXY)
                                                  }}
                                        />
                                    </Form.Field>
                                </Form.Group>
                                <Form.Group widths='equal'>
                                    <Form.Field>
                                        <Input
                                            type="text"
                                            value={fResolutionX}
                                            onChange={(e) => {
                                                setfResolutionX(e.target.value)
                                            }} />
                                    </Form.Field>
                                    <Form.Field>
                                        <Input
                                            type="text"
                                            value={fResolutionY}
                                            onChange={(e) => {
                                                setfResolutionY(e.target.value)
                                            }} />

                                    </Form.Field>
                                </Form.Group>
                                <Form.Group widths='equal'>
                                    <Form.Field>
                                        <Checkbox style={{width:'220px',    border: 'none'}} label='Use Uploaded Video Resolution'
                                                  checked={!fIsUseResolutionXY}
                                                  onChange={(e) => {
                                                      setfIsUseResolutionXY(!fIsUseResolutionXY)
                                                  }}
                                        />

                                    </Form.Field>
                                </Form.Group>
                            </Segment>

                            <Segment style={styleFbg}>
                                <Form.Group >
                                    <Checkbox style={{width:'220px',    border: 'none'}} label='Character'
                                              checked={fCharacterByteType}
                                              onChange={(e) => {
                                                  setfCharacterByteType(!fCharacterByteType)
                                              }}
                                    />
                                    <Checkbox style={{width:'220px',    border: 'none'}} label='Byte'
                                              checked={!fCharacterByteType}
                                              onChange={(e) => {
                                                  setfCharacterByteType(!fCharacterByteType)
                                              }}
                                    />
                                </Form.Group>
                                <Form.Group widths='equal'>
                                    <Form.Field>
                                        <label>Minimum length per line</label>
                                        <Input
                                            type="text"
                                            value={fMinLengthPerLine}
                                            onChange={(e) => {
                                                setfMinLengthPerLine(e.target.value)
                                            }} />
                                    </Form.Field>
                                    <Form.Field>
                                        <label>Maximum length per line</label>
                                        <Input
                                            type="text"
                                            value={fMaxLengthPerLine}
                                            onChange={(e) => {
                                                setfMaxLengthPerLine(e.target.value)
                                            }} />
                                    </Form.Field>
                                </Form.Group>
                            </Segment>

                            <Segment style={styleFbg}>
                                <Form.Group >

                                    <Checkbox style={{width:'220px',    border: 'none'}} label='Character Per Second'
                                              checked={fIsCharacterPerSecondType}
                                              onChange={(e) => {
                                                  setfIsCharacterPerSecondType(!fIsCharacterPerSecondType)
                                              }}
                                    />

                                    <Checkbox style={{width:'220px',    border: 'none'}} label='Word Per Minute'
                                              checked={!fIsCharacterPerSecondType}
                                              onChange={(e) => {
                                                  setfIsCharacterPerSecondType(!fIsCharacterPerSecondType)
                                              }}
                                    />
                                </Form.Group>
                                <Form.Group widths='equal'>
                                    <Form.Field>
                                        <label>Minimum length</label>
                                        <Input
                                            type="text"
                                            value={fMinLengthPerSecond}
                                            onChange={(e) => {
                                                setfMinLengthPerSecond(e.target.value)
                                            }} />
                                    </Form.Field>
                                    <Form.Field>
                                        <label>Maximum length</label>
                                        <Input
                                            type="text"
                                            value={fMaxLengthPerSecond}
                                            onChange={(e) => {
                                                setfMaxLengthPerSecond(e.target.value)
                                            }} />
                                    </Form.Field>
                                </Form.Group>

                                <Form.Group  >
                                    <Form.Field >
                                        <Checkbox style={{width:'220px',    border: 'none'}} label='Exclude spaces'
                                                  checked={fIsExcludeSpaces}
                                                  onChange={(e) => {
                                                      setfIsExcludeSpaces(!fIsExcludeSpaces)
                                                  }}
                                        />
                                    </Form.Field>
                                    <Form.Field >
                                        <Checkbox style={{width:'220px',    border: 'none'}} label='Exclude punctuations and symbols (must be separated by spaces)'
                                                  checked={fIsExcludePunctuations}
                                                  onChange={(e) => {
                                                      setfIsExcludePunctuations(!fIsExcludePunctuations)
                                                  }}
                                        />
                                    </Form.Field>
                                </Form.Group>
                            </Segment>
                        </Form>

                    </Grid.Column>

                    <Grid.Column>

                        <Segment style={styleFbg}>
                            <Form.Group >
                                <Form.Field>
                                    <label>Safe Area X</label>
                                    <div className={"my-2"}>
                                        <Range
                                            min={0}
                                            max={100}
                                            defaultValue={[13, 87]}

                                            onChange={(e)=>{

                                                setfSaveAreaXLeft(100 - e[0]);
                                                setfSaveAreaXRight( e[1]);
                                            }}
                                        />
                                    </div>
                                    <Input
                                        type="text"
                                        value={fSaveAreaXLeft}
                                        onChange={(e) => {
                                            setfSaveAreaXLeft(e.target.value)
                                        }} />
                                    <Input
                                        className={"mr-2"}
                                        type="text"
                                        value={fSaveAreaXRight}
                                        onChange={(e) => {
                                            setfSaveAreaXRight(e.target.value)
                                        }} />

                                </Form.Field>
                            </Form.Group>
                        </Segment>

                        <Segment style={styleFbg}>
                            <Form.Group >
                                <Form.Field>
                                    <label>Safe Area Y</label>
                                    <div className={"my-2"} style={{height:'100px'}}>
                                        <Range vertical
                                               min={0}
                                               max={100}
                                               defaultValue={[10, 90]}

                                               onChange={(e)=>{
                                                   setfSaveAreaYTop(e[1]);
                                                   setfSaveAreaYBottom(100 - e[0] );
                                               }}
                                        />
                                    </div>
                                    <Input
                                        className={"mr-2"}
                                        type="text"
                                        value={fSaveAreaYTop}
                                        onChange={(e) => {
                                            setfSaveAreaYTop(e.target.value)
                                        }} />
                                    <Input
                                        type="text"
                                        value={fSaveAreaYBottom}
                                        onChange={(e) => {
                                            setfSaveAreaYBottom(e.target.value)
                                        }} />
                                </Form.Field>
                            </Form.Group>
                        </Segment>

                        <Segment style={styleFbg}>
                            <label><b>Font</b></label>
                            <Form.Group >
                                <Select placeholder='Arial' options={fontList}  onChange={(event, result) => {
                                    const { value } = result || event.target;

                                    const obj = fontList[parseInt(value)];
                                    const {text} = obj;
                                    setfFontId(value);
                                    setfFontFamily(text);
                                }} />
                            </Form.Group>

                            <Divider />

                            <Form.Field>
                                <label>Font Size</label>
                                <div className={"my-2"}>
                                    <Slider
                                        min={8}
                                        max={30}
                                        defaultValue={fFontSize}

                                        onChange={(e)=>{
                                            setfFontSize(e);
                                        }}
                                    />
                                </div>
                                <Input
                                    className={"mr-2"}
                                    type="text"
                                    value={fFontSize}
                                    onChange={(e) => {
                                        setfFontSize(e.target.value)
                                    }} />
                            </Form.Field>

                            <Divider />

                            <Form.Field>
                                <label>Line Spacing</label>
                                <div className={"my-2"}>
                                    <Slider
                                        min={8}
                                        max={30}

                                        defaultValue={fLineSpacing}

                                        onChange={(e) => {
                                            setfLineSpacing(e)
                                    }}/>
                                </div>
                                <Input
                                    className={"mr-2"}
                                    type="text"
                                    value={fLineSpacing}
                                    onChange={(e) => {
                                        setfLineSpacing(e.target.value)
                                    }} />
                            </Form.Field>

                            <Divider />

                            <Form.Field>
                                <label>Character Spacing</label>
                                <div className={"my-2"}>
                                    <Slider
                                        min={2}
                                        max={30}

                                        defaultValue={fCharaterSpacing}

                                        onChange={(e) => {
                                            setfCharaterSpacing(e)
                                        }}/>
                                </div>
                                <Input
                                    className={"mr-2"}
                                    type="text"
                                    value={fCharaterSpacing}
                                    onChange={(e) => {
                                        setfCharaterSpacing(e.target.value)
                                    }} />
                            </Form.Field>

                        </Segment>


                        <Segment style={styleFbg}>
                            <Form.Group className={"pb-3"}  >
                                <Form.Field >
                                    <label>Minimum Duration</label>
                                </Form.Field>
                                <Grid divided='vertically' className={"p-3  "} style={{width:'420px' }} >
                                    <Grid.Row columns={4}  className={"p-0 m-0"}>
                                        <Input
                                            style={{width:'55px',height:'30px',backgroundColor:'gray'}}
                                            disabled={true}
                                            type="text"
                                            value={'00'} />&nbsp;:&nbsp;
                                        <Input
                                            style={{width:'55px',height:'30px',backgroundColor:'gray'}}
                                            disabled={true}
                                            type="text"
                                            value={'00'} />&nbsp;:&nbsp;
                                        <Input
                                            style={{width:'55px',height:'30px'}}
                                            type="text"
                                            value={fMinDurationSecond}
                                            onChange={(e) => {
                                                setfMinDurationSecond(e.target.value)
                                            }}
                                        />&nbsp;.&nbsp;
                                        <Input
                                            style={{width:'55px',height:'30px'}}
                                            type="text"value={fMinDurationFram}
                                            onChange={(e) => {
                                                setfMinDurationFram(e.target.value)
                                            }} />
                                    </Grid.Row>
                                </Grid>
                            </Form.Group>

                            <Form.Group  >
                                <Form.Field >
                                    <label>Maximun Duration</label>
                                </Form.Field>
                                <Grid divided='vertically' className={"p-3  "} style={{width:'420px' }} >
                                    <Grid.Row columns={4}  className={"p-0 m-0"}>
                                        <Input
                                            style={{width:'55px',height:'30px',backgroundColor:'gray'}}
                                            disabled={true}
                                            type="text"
                                            value={'00'} />&nbsp;:&nbsp;
                                        <Input
                                            style={{width:'55px',height:'30px',backgroundColor:'gray'}}
                                            disabled={true}
                                            type="text"
                                            value={'00'} />&nbsp;:&nbsp;
                                        <Input
                                            style={{width:'55px',height:'30px'}}
                                            type="text"
                                            value={fMaxDurationSecond}
                                            onChange={(e) => {
                                                setfMaxDurationSecond(e.target.value)
                                            }}
                                        />&nbsp;.&nbsp;
                                        <Input
                                            style={{width:'55px',height:'30px'}}
                                            type="text"value={fMaxDurationFram}
                                            onChange={(e) => {
                                                setfMaxDurationFram(e.target.value)
                                            }} />
                                    </Grid.Row>
                                </Grid>
                            </Form.Group>
                        </Segment>

                        <Segment style={styleFbg}>
                            <Form.Group >
                                <Form.Field>
                                    <label>Maximum count of lines</label>
                                    <Input
                                        type="text"
                                        value={fMaxCountOfLines}
                                        onChange={(e) => {
                                            setfMaxCountOfLines(e.target.value)
                                        }} />
                                </Form.Field>
                            </Form.Group>
                        </Segment>
                    </Grid.Column>

                    <Grid.Column>
                        <Segment style={styleFbg}>
                            <Form.Group >
                                <label><b>Allow Positioning</b></label>
                                <Form.Field>　
                                    <Checkbox style={{width:'220px',    border: 'none'}} label='Left,Center, Right, Line Down, Line Up'
                                              checked={fAllowPositioningType}
                                              onChange={(e) => {
                                                  setfAllowPositioningType(!fAllowPositioningType)
                                              }}
                                    />
                                    <Checkbox style={{width:'220px',    border: 'none'}} label='Top/Bottom Only (Netflix TTML)'
                                              checked={!fAllowPositioningType}
                                              onChange={(e) => {
                                                  setfAllowPositioningType(!fAllowPositioningType)
                                              }}
                                    />　
                                </Form.Field>

                                <Divider />

                                <label><b>Center Justification</b></label>
                                <Form.Field>

                                    <Checkbox style={{width:'80px',    border: 'none'}} label='Left'
                                              checked={(fCenterJustificationType===0)}
                                              onChange={(e) => {
                                                  setfCenterJustificationType(0)
                                              }}
                                    />

                                    <Checkbox style={{width:'80px',    border: 'none'}} label='Center'
                                              checked={(fCenterJustificationType===1)}
                                              onChange={(e) => {
                                                  setfCenterJustificationType(1)
                                              }}
                                    />
                                    <Checkbox style={{width:'80px',    border: 'none'}} label='Right'
                                              checked={(fCenterJustificationType===2)}
                                              onChange={(e) => {
                                                  setfCenterJustificationType(2)
                                              }}
                                    />
                                </Form.Field>

                                <Divider />

                                <label><b>Remove continuous whitespace</b></label>
                                <Form.Field>
                                    <Checkbox style={{width:'80px',    border: 'none'}} label='on'
                                              checked={fIsRemoveContinuousWhitespace}
                                              onChange={(e) => {
                                                  setfIsRemoveContinuousWhitespace(!fIsRemoveContinuousWhitespace)
                                              }}
                                    />

                                    <Checkbox style={{width:'80px',    border: 'none'}} label='off'
                                              checked={!fIsRemoveContinuousWhitespace}
                                              onChange={(e) => {
                                                  setfIsRemoveContinuousWhitespace(!fIsRemoveContinuousWhitespace)
                                              }}
                                    />
                                </Form.Field>


                            </Form.Group>
                        </Segment>


                        <Segment style={styleFbg}>
                            <Form.Group >
                                <label><b>QcReport Timecode Check List</b></label>
                                <Form.Field>
                                    <Checkbox
                                        style={{width:'220px',    border: 'none'}}
                                        label='Missing Timecode Error'
                                        checked={fQC_MissingTimecodeError}
                                        onChange={(e) => {
                                            setfQC_MissingTimecodeError(!fQC_MissingTimecodeError)
                                        }}/>
                                    <Checkbox
                                        style={{width:'220px',    border: 'none'}}
                                        label='Timecode Overlap Error'
                                        checked={fQC_TimecodeOverlapError}
                                        onChange={(e) => {
                                            setfQC_TimecodeOverlapError(!fQC_TimecodeOverlapError)
                                        }}/>
                                    <Checkbox
                                        style={{width:'220px',    border: 'none'}}
                                        label='Duration Error (Min)'
                                        checked={fQC_DurationError_min}
                                        onChange={(e) => {
                                            setfQC_DurationError_min(!fQC_DurationError_min)
                                        }}/>
                                    <Checkbox
                                        style={{width:'220px',    border: 'none'}}
                                        label='Duration Error (Max)'
                                        checked={fQC_DurationError_max}
                                        onChange={(e) => {
                                            setfQC_DurationError_max(!fQC_DurationError_max)
                                        }}/>
                                </Form.Field>
                            </Form.Group>
                        </Segment>

                        <Segment style={styleFbg}>
                            <Form.Group >
                                <label><b>QcReport Subtitle Check List</b></label>
                                <Form.Field>
                                    <Checkbox
                                        style={{width:'220px',    border: 'none'}}
                                        label='Empty Subtitle/Caption Error'
                                        checked={fQC_EmptySubError}
                                        onChange={(e) => {
                                            setfQC_EmptySubError(!fQC_EmptySubError)
                                        }}/>
                                    <Checkbox
                                        style={{width:'220px',    border: 'none'}}
                                        label='Character Limit Error'
                                        checked={fQC_ChartacterLimtError}
                                        onChange={(e) => {
                                            setfQC_ChartacterLimtError(!fQC_ChartacterLimtError)
                                        }}/>
                                    <Checkbox
                                        style={{width:'220px',    border: 'none'}}
                                        label='Reading Speed Error'
                                        checked={fQC_ReadSpeedError}
                                        onChange={(e) => {
                                            setfQC_ReadSpeedError(!fQC_ReadSpeedError)
                                        }}/>
                                    <Checkbox
                                        style={{width:'220px',    border: 'none'}}
                                        label='Maximum Line Error'
                                        checked={fQC_MaxLineError}
                                        onChange={(e) => {
                                            setfQC_MaxLineError(!fQC_MaxLineError)
                                        }}/>
                                    <Checkbox
                                        style={{width:'220px',    border: 'none'}}
                                        label='Positioning Check'
                                        checked={fQC_PositionCheckError}
                                        onChange={(e) => {
                                            setfQC_PositionCheckError(!fQC_PositionCheckError)
                                        }}/>
                                    <Checkbox
                                        style={{width:'220px',    border: 'none'}}
                                        label='Netflix Whitelist Characters Error'
                                        checked={fQC_NetflixWhitelistCharactersCheckError}
                                        onChange={(e) => {
                                            setfQC_NetflixWhitelistCharactersCheckError(!fQC_NetflixWhitelistCharactersCheckError)
                                        }}/>
                                    <Checkbox
                                        style={{width:'220px',    border: 'none'}}
                                        label='Half-Width Characters Check'
                                        checked={fQC_Half_white_ChartaterError}
                                        onChange={(e) => {
                                            setfQC_Half_white_ChartaterError(!fQC_Half_white_ChartaterError)
                                        }}/>
                                    <Checkbox
                                        style={{width:'220px',    border: 'none'}}
                                        label='Simplified Chinese Character Check'
                                        checked={fQC_SimplifiedError}
                                        onChange={(e) => {
                                            setfQC_SimplifiedError(!fQC_SimplifiedError)
                                        }}/>
                                </Form.Field>
                            </Form.Group>
                        </Segment>

                        {actionbutton()}


                    </Grid.Column>
                </Grid.Row>
            </Grid>



        </div>}
    </div>;
};

export default StylePage_Add;



// WEBPACK FOOTER //
// ./src/components/Style/StylePage_Add.js